import Parser from "../classes/jsonapi_parser";

export default {
  watch: {
    recordUrlParams: {
      handler: function() {
        if (typeof this.recordUrl !== "undefined" && this.recordUrl !== null) {
          this.getRecordsFromAPI();
        }
      },
      deep: true
    }
  },

  methods: {
    getRecordsFromAPI(page) {
      if (page == null) {
        page = 1;
      }

      let params = {
        page
      };

      if (this.sortBy && this.sortBy.by) {
        params.sort = this.sortBy.by;

        if (this.sortBy.dir) {
          params.sort += ":" + this.sortBy.dir;
        }
      }

      if (this.currentFilter && this.currentFilter.params) {
        Object.assign(params, this.currentFilter.params);
      }

      for (var key in this.recordUrlParams) {
        if (
          Object.hasOwnProperty.call(this.recordUrlParams, key) &&
          this.recordUrlParams[key]
        ) {
          params[key] = this.recordUrlParams[key];
        }
      }

      let headers = {};
        if (this.useJsonApi) {
            headers = {
                Accept: "application/vnd.api+json"
            };
        }

      this.loadingData = true;
      this.apiClient
        .get(this.recordUrl, {
          params,
            headers
        })
        .then(
          response => {
            this.loadingData = false;

            if (this.useJsonApi) {
              let apiResponse = this.jsonApiParser.parseJSONAPIResponse(
                response.data
              );
              // remove collection from apiResponse if the parser turned the response into a collection
              if (typeof apiResponse.paginate == "function") {
                apiResponse = apiResponse.paginate();
              }

              this.gridData = apiResponse;
              if (apiResponse.current_page) {
                this.internalCurrentPage = apiResponse.current_page;
              }
              this.setPagination();
              return;
            }

            if (typeof response.data.data != "undefined") {
              this.gridData = response.data;
              if (response.data.current_page) {
                this.internalCurrentPage = response.data.current_page;
              }
              this.setPagination();
            } else {
              this.gridData = response.data;
            }
          },
          error => {
            this.loadingData = false;

            if (!error.data) {
              throw new Error(error);
            }
          }
        );
    }
  }
};
